import Logo from "../assets/logo.png"
// import AppleLogo from "../assets/apple.svg"
import { Link } from 'react-router-dom'

const Navbar = () => {
    return (
        <nav className="absolute top-0 w-full z-20"> 
            <div className="flex items-center justify-between w-full px-8 py-5 bg-white/50 backdrop-blur-sm">
                
                <Link to="/">
                    <div className="flex items-center">
                        <img src={Logo} alt="Logo" className="w-8 h-8" />
                        <h1 className="pl-3 text-xl font-medium text-[#1A1A1A] cursor-pointer hover:opacity-80 transition">
                            Sentivo
                        </h1>
                    </div>
                </Link>

                {/* <div className="absolute left-1/2 transform -translate-x-1/2 flex items-center space-x-8">
                    <a href="#demo" className="text-sm font-medium text-gray-700 hover:text-black transition duration-200">
                        Demo
                    </a>
                    <a href="#features" className="text-sm font-medium text-gray-700 hover:text-black transition duration-200">
                        Features
                    </a>
                </div> */}
                
                {/* <a href="https://pub-6f7c3d3ca81344b2ac370e1a84d731b4.r2.dev/Sentivo.dmg" className="flex items-center space-x-2 bg-[#1A1A1A] text-white font-semibold text-sm py-3 px-6 rounded-xl shadow-xl hover:bg-black transition-colors duration-200">
                    <img src={AppleLogo} alt="Apple Logo" className="w-5 h-5" />
                    <span>Download</span>
                </a> */}
                {/* <a href="#" className="text-sm font-semibold text-gray-700 hover:text-black py-1 px-3 transition duration-200 rounded-lg hover:bg-gray-100">
                    Sign In
                </a> */}
            </div>
        </nav>
    );
}

export default Navbar;